import { callCommand } from './oo-utils'

export const parseTables = async (context, window) => {
    const tables = await callCommand({context}, (Api) => {
        const doc = Api.GetDocument()
        const tables = doc.GetAllTables()
        const collapseContent = c => {
            const ret: Array<string> = []
            if (c) {
                if (typeof c == 'string')
                    ret.push(c)
                else if (Array.isArray(c)) {
                    for (const inner of c) 
                        ret.push(collapseContent(inner))
                }
                else if (typeof c == 'object') {
                    if (c.content) {
                        ret.push(collapseContent(c.content))
                    } else {
                        if (c.type) {
                            if (c.type == 'break')
                                ret.push('\n')
                            else
                                console.warn(`Unknown content type: ${c.type}`)
                        } else {
                            console.warn(`Unknown content value: ${c}`)
                        }
                    }
                } else {
                    console.warn(`Unknown content type: ${typeof c}`)
                }
            }
            return ret.join('')
        }
        const resultedTables: Array<Array<Array<string>>> = []
        for (const table of tables.map(t => t.ToJSON())) {
            const parsed: Array<Array<string>> = []
            const t = JSON.parse(table)
            for (const row of t.content) {
                const ready: Array<string> = []
                for (const column of row.content) {
                    ready.push(collapseContent(column).trim())
                }
                parsed.push(ready)
            }
            resultedTables.push(parsed)
        }
        return resultedTables
    })
    console.log(tables)
}
